import DeAt from '../../app/localization//de-at';
import DeDe from '../../app/localization//de-de';
import DaDk from '../../app/localization/da-dk';
import DeCh from '../../app/localization/de-ch';
import EnGb from '../../app/localization/en-gb';
import EnUs from '../../app/localization/en-us';
import FrBe from '../../app/localization/fr-be';
import FrCh from '../../app/localization/fr-ch';
import FrFr from '../../app/localization/fr-fr';
import NbNo from '../../app/localization/nb-no';
import NlBe from '../../app/localization/nl-be';
import NlNl from '../../app/localization/nl-nl';
import PlPl from '../../app/localization/pl-pl';
import { SiteTranslation } from '../../app/localization/SiteTranslation';
import SvSe from '../../app/localization/sv-se';
import { TranslationResolver } from '../../app/localization/TranslationResolver';

class TranslationResolverFactory {
  public static create(): TranslationResolver<SiteTranslation> {
    const translations = new Map<string, SiteTranslation>([
      ['en-us', EnUs],
      ['nb-no', NbNo],
      ['da-dk', DaDk],
      ['de-de', DeDe],
      ['de-at', DeAt],
      ['de-ch', DeCh],
      ['en-gb', EnGb],
      ['fr-be', FrBe],
      ['fr-ch', FrCh],
      ['fr-fr', FrFr],
      ['nl-be', NlBe],
      ['nl-nl', NlNl],
      ['pl-pl', PlPl],
      ['sv-Se', SvSe],
    ]);
    const defaultLanguageCode = 'en-us';

    return new TranslationResolver<SiteTranslation>(translations, defaultLanguageCode);
  }
}

export default TranslationResolverFactory;
